import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { GenericObject } from "../../../../@types";
import { decodeAttributesUrl } from "../../../../utils/data-encoding";
import { URL_PARAMS } from "../../constants";

const EMPTY_DEFAULT_VALUES: GenericObject<string> = {};

export function useUrlDefaultAttributes(): GenericObject<string> {
  const { search } = useLocation();

  return useMemo(() => {
    const attrsParam = new URLSearchParams(search).get(URL_PARAMS.ATTRS);
    if (!attrsParam) return EMPTY_DEFAULT_VALUES;
    return decodeAttributesUrl(attrsParam);
  }, [search]);
}
